"use client";

import { useEffect, useState } from "react";
import { decodeEmailPayload } from "@/lib/contact/obfuscate";

type ObfuscatedEmailProps = {
  /** XOR-encoded char codes — no plain `@` or domain in HTML source. */
  payload: number[];
  className?: string;
};

export function ObfuscatedEmail({ payload, className }: ObfuscatedEmailProps) {
  const [email, setEmail] = useState<string | null>(null);

  useEffect(() => {
    setEmail(decodeEmailPayload(payload));
  }, [payload]);

  if (!email) {
    return (
      <span className={className} aria-busy="true">
        {/* Placeholder keeps layout stable; real address renders after hydration. */}
        <span className="inline-block min-w-[12rem] opacity-0">placeholder</span>
      </span>
    );
  }

  return (
    <a href={`mailto:${email}`} className={className} title={email}>
      {email}
    </a>
  );
}
